var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img",class:{ lazy: _vm.loader, loaded: _vm.loaded, 'img--contain': _vm.contain },attrs:{"src":_vm.src || _vm.source,"alt":_vm.head_img ? _vm.head_img.alt : '',"loading":"lazy"},on:{"load":function($event){_vm.loaded = true},"error":function($event){_vm.loaded = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }